const getters = {
	// data
	getRekeningBank: (state) => state.rekeningBank,
	getRekeningBankDetail: (state) => state.rekeningBankDetail,
	getRekeningAtasNama: (state) => state.rekeningAtasNama,
	getAkunKeuangan: (state) => state.akunKeuangan,
	getRiwayatTransfer: (state) => state.riwayatTransfer,
	getRiwayatTransferDetail: (state) => state.riwayatTransferDetail,

	// filter
	getPagination: (state) => state.pagination,
	getPaginationRiwayatTransfer: (state) => state.paginationRiwayatTransfer,
	getSearch: (state) => state.search,
	getSearchRiwayatTransfer: (state) => state.searchRiwayatTransfer,
	getIsSearch: (state) => state.isSearch,
	getIsSearchRiwayatTransfer: (state) => state.isSearchRiwayatTransfer,

	getScrollPosition: (state) => state.scrollPosition,
	getScrollPositionRiwayatTransfer: (state) => state.scrollPositionRiwayatTransfer
}

export default getters